import { render, staticRenderFns } from "./RatingsDisplay.vue?vue&type=template&id=27d0ace1&scoped=true&"
import script from "./RatingsDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RatingsDisplay.vue?vue&type=style&index=0&id=27d0ace1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0ace1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d0ace1')) {
      api.createRecord('27d0ace1', component.options)
    } else {
      api.reload('27d0ace1', component.options)
    }
    module.hot.accept("./RatingsDisplay.vue?vue&type=template&id=27d0ace1&scoped=true&", function () {
      api.rerender('27d0ace1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/components/RatingsDisplay.vue"
export default component.exports